import { render, staticRenderFns } from "./Draw.vue?vue&type=template&id=3af819c3&scoped=true&lang=pug&"
import script from "./Draw.vue?vue&type=script&lang=js&"
export * from "./Draw.vue?vue&type=script&lang=js&"
import style0 from "./Draw.vue?vue&type=style&index=0&id=3af819c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af819c3",
  null
  
)

export default component.exports